import React, { useEffect } from 'react';
import styles from './TruemedWidget.module.scss';
import { TRUEMED_QUALIFICATION_ID, TRUEMED_SCRIPT_URL } from './constants';

const TruemedWidget = () => {

  useEffect(() => {
    const truemedWidgetScript = document.getElementById('truemed-widget-script');
    if (!truemedWidgetScript) {
      const s = document.createElement('script');
      s.id = 'truemed-widget-script';
      s.type = 'text/javascript';
      s.async = true;
      s.src = TRUEMED_SCRIPT_URL;
      document.getElementsByTagName('body')[0].appendChild(s);
    }
  }, []);

  return (
    <div className={styles['truemed-widget-container']}>
      <div id="truemed-instructions" className={styles['truemed-widget']} data-public-id={TRUEMED_QUALIFICATION_ID} />
    </div>
  );
};

export default TruemedWidget;